import { faDashboard } from './../../../../../node_modules/@fortawesome/free-solid-svg-icons/faDashboard.d';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SettlementsService } from 'src/app/services/settlements.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { BreadcrumbService } from 'xng-breadcrumb';
import { IconsService } from 'src/app/shared/services/icons.service';

import { Tanque } from 'src/app/models/tanque.model';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { Settlement } from 'src/app/models/settlement.model';
import { Building } from 'src/app/models/building.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { InfiniteSelectComponent } from 'src/app/components/inputs/infinite-select/infinite-select.component';

@Component({
  selector: 'app-tanques',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Combustible</h1>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">        
        <ul #subnav app-nav-tanques [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="d-flex mb-3">
          <div class="flex-fill ms-2">
            <h2 class="mt-2 mt-md-0 mb-0">Tanques</h2>
            <p class="text-muted" style="font-size: 14px;">Configura los tanques asignados a los edificios.</p>
          </div>
        </div>
        <div class="d-flex">
          <div class="flex-fill ms-3 me-3">
            <div class="input-group mb-3">
              <input class="form-control border-secondary border-end-0 rounded-start-3 bg-transparent" placeholder="Buscar..." [formControl]="search">
              <div class="input-group-append border border-secondary border-start-0 rounded-end-3 bg-transparent">
                <fa-icon [icon]="icons.faSearch" *ngIf="!search.value" class="input-group-text bg-transparent border-0 mt-1"></fa-icon>
                <fa-icon [icon]="icons.faTimes" *ngIf="search.value" (click)="clearSearch()" class="input-group-text bg-transparent border-0 mt-1"></fa-icon>
              </div>
            </div>
          </div>
          <div>
            <app-infinite-select
              [fetchPage]="settlementsFetcher"
              [pageSize]="settlementsPageSize"
              [labelKey]="'name'"
              [valueKey]="'id'"
              [placeholder]="'Condominio'"
              [allOptionLabel]="'Condominio'"
              [allOptionValue]="0"
              [triggerClass]="'form-select border-secondary rounded-3 bg-transparent'"
              [panelMaxHeight]="260"
              [showCaret]="false"
              (selectionChange)="selectSettlement($event)"
              (itemsChange)="settlements = $event"
              [(ngModel)]="selectedSettlementId"
            ></app-infinite-select>
          </div>
          <div class="text-end">
            <button class="btn btn-zazz-dark ms-2 shadow-sm" routerLink="create">
              <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
              Agregar tanque
            </button>
          </div>
        </div>
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          <div class="list-group-item table-responsive py-4">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3">Tanque</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2">Condominio</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Capacidad</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Límites</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2"></th>
                </tr>
              </thead>
              <tbody *ngIf="tanques.length>0">
                <tr app-tr-tanques 
                  [tanque]="tanque" 
                  [settlements]="settlements" 
                  [profile]="profile" 
                  [permissions]="permissions"
                  *ngFor="let tanque of tanques | paginate: { 
                    itemsPerPage: payload.per_page, 
                    currentPage: p, 
                    totalItems: meta.total_entries 
                  }"
                >
                </tr>
              </tbody>
            </table>
            <div class="text-center py-5" *ngIf="tanques.length==0&&loading">
              <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
              <p class="text-muted">Cargando...</p>
            </div>
            <div class="text-center py-5" *ngIf="tanques.length==0&&!loading" >
              <img src="/assets/images/empty-state.png" width="240px">
              <p class="text-muted">No se encontraron registros</p>
            </div>
          </div>
          <div class="list-group-item text-center pt-3">
            <pagination-controls
              (pageChange)="p = $event"
              (pageChange)="pageChanged($event)"
              previousLabel="Prev."
              nextLabel="Sig."
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>
    
  `,
  styleUrls: []
})
export class TanquesComponent implements OnInit {
  @ViewChild(InfiniteSelectComponent) settlementSelect?: InfiniteSelectComponent<Settlement>;

  tanques: Tanque[] = [];
  settlements: Settlement[] = [];
  buildings: Building[] = [];
  meta: any = {};
  profile: any = {};
  permissions: any = {};

  loading: boolean = false;
  currentView: string = 'tanques';
  search: FormControl = new FormControl();
  selectedSettlementId = 0;
  settlementsPageSize = 10;
  
  payload: any = {
    page: 1,
    per_page: 10,
  };

  p: number = 1;
  storageService = inject(StorageService);
  settlementsFetcher = (params: any) => {
    const payload: any = {
      page: params.page,
      per_page: params.per_page
    };
    if (this.profile?.utility_id) {
      payload.utility_id = this.profile.utility_id;
    }
    if (params.search) {
      payload.name = params.search;
    }
    return this.store.getSettlements(payload);
  };
  constructor(
    private store: SettlementsService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    public icons: IconsService,
    public authService: AuthService,
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    this.payload.profile_id = this.profile ? this.profile.id : 0;
  }

  ngOnInit(): void {
    this.loadTanks(this.payload);
    this.breadcrumbService.set('@tanque', 'Tanques');
    console.log('search => ', this.search.value);

    this.search.valueChanges.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap((term: string) => {
        if (!term) {
          return this.store.getTanques({
            profile_id: this.payload.profile_id,
            page: 1,
            per_page: this.payload.per_page
          });
        } else {
          return this.store.getTanques({
            name: term, 
            profile_id: this.payload.profile_id,
            page: 1,
            per_page: this.payload.per_page
          })
        }
      })).subscribe((data: any) => {
        this.tanques = data.data;
        this.meta = data.meta;
      });
  }

  loadTanks(payload: any) {
    this.loading = true;
    this.store.getTanques(payload).subscribe({
      next: (data: any) => {
        console.log('TANQUES => ', data);
        this.tanques = data.data;
        this.meta = data.meta;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.toastr.error('No se pudieron cargar los tanques', 'Error');
      }
    });
  }

  selectSettlement(eventOrValue: any) {
    const value = eventOrValue?.target ? eventOrValue.target.value : eventOrValue;
    if (value == 0 || value === null || value === undefined || value === '') {
      delete this.payload.settlement_id;
    } else {
      this.payload.settlement_id = value;
    }
    this.loadTanks(this.payload);
  }

  clearSearch() {
    delete this.payload.name;
    this.search.setValue(null);    
    this.loadTanks(this.payload);
  }

  clearFilter() {
    delete this.payload.settlement_id;
    this.selectedSettlementId = 0;
    this.loadTanks(this.payload);
    this.settlementSelect?.reset();
  }

  pageChanged(event: any) {
    this.payload.page = event;
    this.loadTanks(this.payload);
  }

  

}
